import { PageStatus } from "@monthly/ui";
import { createFileRoute } from "@tanstack/react-router";

import { Error500 } from "~/assets/svg";

export const Route = createFileRoute("/error")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageStatus
      title="Este enlace ha expirado y ya no está disponible"
      description="Es necesario generar un nuevo enlace en Monthly para visualizar o compartir este Spotlight."
      icon={<Error500 />}
    />
  );
}
